import classNames from "classnames";
import Icon from "./icon";

const SwiperArrow = ({ next = false, ref }) => {
  return (
    <button
      className={classNames("pick-up-slots__arrow swiper-button", {
        "swiper-button--prev": !next,
        "pick-up-slots__arrow--next swiper-button--next": next,
      })}
      ref={ref}
      aria-label="Arrow"
    >
      <Icon name="angle-down" />
    </button>
  );
};

export default SwiperArrow;
